export default class RemovedScoresModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.scores === undefined) {
            return;
        }

        const scores = content.scores.remove;

        if (scores !== undefined) {
            for (let i = 0; i < scores.length; i++) {
                scores[i] = this._modelKeyRepository.removeScore(scores[i]);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/RemovedScoresModifier.js